import { render, staticRenderFns } from "./resize-bar.vue?vue&type=template&id=5069e800&scoped=true&"
import script from "./resize-bar.vue?vue&type=script&lang=js&"
export * from "./resize-bar.vue?vue&type=script&lang=js&"
import style0 from "./resize-bar.vue?vue&type=style&index=0&id=5069e800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5069e800",
  null
  
)

export default component.exports